import React, { FC, useState } from 'react';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { DeleteIcon } from 'cokitchen-icons';
import { toast } from 'react-toastify';
import { UserType } from 'models/user.model';
import { apiService } from 'utils/api';
import { getUserName } from 'utils/functions';

interface DeleteRepModalProps {
  show: boolean;
  onClose: (withRes?: boolean) => void;
  singleRep?: UserType;
}

interface DeleteRepModalFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteRepModalFooter: FC<DeleteRepModalFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const DeleteRepModal: FC<DeleteRepModalProps> = ({ show, onClose, singleRep }) => {
  const [loading, setLoading] = useState(false);

  const confirmDelete = async () => {
    try {
      const res = await apiService.post(`cs/staff/delete`, {
        data: {
          user_ids: [singleRep?.id]
        },
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      if (res?.data) {
        toast(<ToastMessage type='success' message='cs rep deleted successfully' />);
        onClose();
      }
    } catch {
      toast(<ToastMessage type='error' message='Error occured while deleting cs rep' />);
    }
    setLoading(false);
  };

  return (
    <BaseModal
      isOpen={show}
      title=''
      description={`Are you sure you want to delete ${getUserName(singleRep)} ${
        singleRep?.last_name
      }`}
      titleIcon={<DeleteIcon className='text-red-5' />}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      footer={
        <DeleteRepModalFooter
          loading={loading}
          onCancel={() => onClose()}
          onConfirm={() => confirmDelete()}
        />
      }
    />
  );
};

export default DeleteRepModal;
